<template>
	<div class="content-wrapper">
		<!-- Content -->

		<div class="container flex-grow-1 container-p-y">
			<div class="spinner-border spinner-border-lg text-primary load-center" role="status" v-if="isLoading">
				<span class="visually-hidden">Loading...</span>
			</div>

			<div class="col-md-12 mb-5" v-if="company">
				<div class="card h-100">
					<div class="card-body pb-4">
						<div class="mb-5">
							<div class="d-flex align-items-center">
								<div class="avatar avatar-md">
									<div class="avatar-initial bg-label-primary rounded-3">
										<i class="ri-bank-card-line ri-24px"></i>
									</div>
								</div>
								<div class="ms-4">
									<h3 class="mb-0">{{ company.credits }}</h3>
									<p class="mb-0">crédits disponibles</p>
								</div>
							</div>
						</div>
						<router-link to="/purchase-credits">
							<button class="btn btn-primary">
								Acheter des credits
							</button>
						</router-link>
					</div>
				</div>
			</div>

			<div class="col-md-12" v-if="!isLoading && transactions.length > 0">
				<div class="card h-100">
					<div class="card-body" >
						<ul class="p-0 m-0">
							<li class="d-flex align-items-center pb-2" v-for="(transaction, index) in transactions" :key="index">
								<div class="me-4">
									<div class="avatar flex-shrink-0" v-if="transaction.type === 'increase'">
										<div class="avatar-initial bg-label-success rounded-3">
											<div>
												<i class="ri-add-circle-line"></i>
											</div>
										</div>
									</div>
									<div class="avatar flex-shrink-0" v-if="transaction.type === 'decrease'">
										<div class="avatar-initial bg-label-danger rounded-3">
											<div>
												<i class="ri-user-minus-line"></i>
											</div>
										</div>
									</div>
								</div>
								<div class="d-flex w-100 flex-wrap align-items-center justify-content-between gap-2">
									<div class="me-2" v-if="transaction.type === 'increase'">
										<h6 class="mb-1">Achat de crédits</h6>
									</div>
									<div class="me-2" v-if="transaction.type === 'decrease'">
										<h6 class="mb-1">Formation {{ transaction.formationName }}</h6>
										<p class="mb-0">Stagiaire: {{ transaction.user }}</p>
									</div>
									<div class="user-progress d-flex align-items-center gap-2" v-if="transaction.type === 'decrease'">
										<h6 class="mb-0 text-danger">-{{ transaction.amount }} crédits</h6>
									</div>
									<div class="user-progress d-flex align-items-center gap-2" v-if="transaction.type === 'increase'">
										<h6 class="mb-0 text-success">+{{ transaction.amount }} crédits</h6>
									</div>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
		<!-- / Content -->
		<div class="content-backdrop fade"></div>
	</div>
</template>

<script>
import HTTP from "@/axios";
import moment from "moment";
import "moment/locale/fr";

moment.locale("fr");

export default {
	name: "TransactionsPage",

	data() {
		return {
			isLoading: false,
			company: null,
			transactions: []
		};
	},

	methods: {
		async fetchCompany() {
			try {
				const response = await HTTP('/company');
				this.company = response.data.company;
			} catch (error) {
				// Récupérer le message d'erreur de l'API ou définir un message par défaut
				const errorMessage = error?.response?.data?.message || "Une erreur est survenue, merci de contacter contact@pika-aero.com";

				alert(errorMessage);

				// Log détaillé dans la console (utile en développement)
				console.error("Erreur API:", error);
			}
		},

		async fetchTransactions() {
			try {
				const response = await HTTP('/company/transactions');
				this.transactions = response.data.transactions;
				this.isLoading = false;
			} catch (error) {
				// Récupérer le message d'erreur de l'API ou définir un message par défaut
				const errorMessage = error?.response?.data?.message || "Une erreur est survenue, merci de contacter contact@pika-aero.com";

				alert(errorMessage);

				// Log détaillé dans la console (utile en développement)
				console.error("Erreur API:", error);
			}
		},

		formatDate(timestamp) {
			return moment.unix(timestamp).format("DD/MM/YYYY"); // Affiche "il y a 3 semaines"
		},

		formatRelativeDate(timestamp) {
			return moment.unix(timestamp).fromNow(); // Affiche "il y a 3 semaines"
		},
	},

	async mounted() {
		this.fetchCompany();
		this.fetchTransactions();
	}
};
</script>

<style scoped>
/* Ajoutez des styles spécifiques à la page Dashboard */
.dashboard {
	padding: 1rem;
}

.card-title {
	font-size: 1.2rem;
}

.card-text {
	margin: 0;
}

.load-center {
	display: block;
	margin: 0 auto;
}
</style>
